import {Group, Stack, Switch, Text} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {
    FEATURE_BUNDLES,
    FeatureBundleKey,
    useFeatureMask,
} from "../../../../featureFlags/featureFlags";
import classes from "./SettingSelectField.module.css";

/**
 * One settings switch per feature bundle: checked when every bit in the
 * bundle's mask is set; toggling sets or clears all of them. Rendered only
 * when the user's role may toggle every bit in the mask. Rows are
 * transparent — they sit on a FeatureToggleGroup tint.
 */
export function FeatureBundleToggle({bundleKey}: {bundleKey: FeatureBundleKey}) {
    const {t} = useTranslation();
    const {mask, setMask, canToggle} = useFeatureMask();
    const bundle = FEATURE_BUNDLES[bundleKey];

    if (!canToggle(bundle.mask)) {
        return null;
    }

    const checked = (mask & bundle.mask) === bundle.mask;

    return (
        <Group className={`${classes.outer} ${classes.flatRow}`}>
            <Stack className={classes.innerItem} gap={0}>
                <Text>
                    {t(`settings.feature.${bundleKey}.label`, {
                        defaultValue: bundle.defaultLabel,
                    })}
                </Text>
                <Text size="xs" c="dimmed">
                    {t(`settings.feature.${bundleKey}.description`, {
                        defaultValue: bundle.defaultDescription,
                    })}
                </Text>
            </Stack>
            <Switch
                classNames={{
                    track: classes.toggleTrack,
                    thumb: classes.toggleThumb,
                }}
                checked={checked}
                onChange={(event) =>
                    setMask(
                        event.currentTarget.checked
                            ? mask | bundle.mask
                            : mask & ~bundle.mask
                    )
                }
            />
        </Group>
    );
}
